import { render } from "./Heatmaps-page.vue?vue&type=template&id=594cc4c4"
import script from "./Heatmaps-page.vue?vue&type=script&lang=js"
export * from "./Heatmaps-page.vue?vue&type=script&lang=js"

import "./Heatmaps-page.vue?vue&type=style&index=0&id=594cc4c4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__